import axios from 'axios'
import config from '../../config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL_v2;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v2`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({
  baseURL: baseUrl,
  timeout: 10000000,
});

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

export default http